import { FamilyUnitsLinks } from "./units";
import React from "react";
import "./units.css";
function Antony() {
    return (
        <div class="content1">
            <FamilyUnitsLinks />
            <h2>St. Antony's Unit</h2>
            <div class="units-page">
                <div class="unit-portion">
                    <div class="unit-left">
                        <table border="1">
                            <tr>
                                <th>Position</th>
                                <th>Name</th>
                                <th>Contact Number</th>
                            </tr>
                            <tr>
                                <td>President</td>
                                <td>Name 1</td>
                                <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                            </tr>
                            <tr>
                                <td>Vice President</td>
                                <td>Name 2</td>
                                <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                            </tr>
                            <tr>
                                <td>Secretary</td>
                                <td>Name 3</td>
                                <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                            </tr>
                            <tr>
                                <td>Treasurer</td>
                                <td>Name 4</td>
                                <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                            </tr>
                        </table>
                    </div>
                    <div class="unit-right">
                        <div class="units-descp">
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!</p>
                        </div>
                    </div>
                </div>
                <div class="unit-group">
                    <img src="/images/cat-gp.jpg" alt="St. Antony" />
                    <h3>St. Antony's Unit Group Photo</h3>
                </div>
                <div class="members-table">
                    <table border="1">
                        <tr>
                            <th>House Name</th>
                            <th>Elder Member Name</th>
                            <th>Contact Number</th>
                        </tr>
                        <tr>
                            <td>Nil</td>
                            <td>Name 1</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                        <tr>
                            <td>Nil</td>
                            <td>Name 2</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                        <tr>
                            <td>Nil</td>
                            <td>Name 3</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                        <tr>
                            <td>Nil</td>
                            <td>Name 4</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    );
};
export default Antony;